module.exports = __webpack_public_path__ + "static/media/clickableQuestions.17d76448.png";